import { ENDPOINT } from '~/constants';

import { type UUID } from '~/types/common';

import { HTTPError, vestigasApi } from '~/services/kyClient';
import ToastService from '~/services/toast.service';

import { i18n, log } from '~/utils';

import { type ReprocessInvoiceResponse } from './types';

/**
 * Reprocess the invoice with the given process ID.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoice/operation/reprocess_invoice_invoice_process__process_id__reprocess_put
 */
export async function reprocessInvoice(processId: UUID) {
  try {
    const response = await vestigasApi
      .put(ENDPOINT.INVOICE_REPROCESSING.REPROCESS(processId))
      .json<ReprocessInvoiceResponse>();

    return response;
  } catch (error) {
    log.error({
      message: 'Error reprocessing invoice',
      error,
    });

    let errorMessage = '';

    if (error instanceof HTTPError) {
      switch (error.response.status) {
        case 422: {
          errorMessage = i18n.t(($) => $.reprocessInvoice.error422, {
            ns: 'data',
          });
          break;
        }

        default: {
          errorMessage = i18n.t(($) => $.reprocessInvoice.error.generic, {
            ns: 'data',
          });
        }
      }
    }

    if (errorMessage) {
      ToastService.error(errorMessage);
    }

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
}
